let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fxzEy")).then(() => parcelRequire('jsBpx'));